import React, { useState } from "react";

function CopyButton({ onCopy }) {
  const [isCopied, setIsCopied] = useState(false);

  return (
    <span
      onClick={(e) => {
        onCopy();
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1000);
      }}
      title="Copy"
      className="bg-gray-100 rounded-full px-[5px] py-[0px] cursor-pointer text-[10px]"
    >
      {isCopied ? "Copied" : "Copy"}
    </span>
  );
}

export default CopyButton;
